import script from "./ProductFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductFooter.vue?vue&type=script&setup=true&lang=js"

import "./ProductFooter.vue?vue&type=style&index=0&id=3ccfd193&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ccfd193"]])

export default __exports__